import React, { useState, useEffect, useRef } from 'react'
import logo from '../static/images/Frame 178.svg'
import CommonButton from './commonButton';
import gsap from 'gsap';
import { Link, navigate } from 'gatsby'
const navLinks = [
  { name: "Home", path: "/" },
  { name: "Products", path: "/products", hasSub: true },
  // { name: "Solutions", path: "/solutions", hasSub: true },
  // { name: "Resources", path: "/resources" },
  { name: "Contact Us", path: "/contact-us" },
  // { name: "Careers", path: "/careers" },
];

const megaMenuData = {
  Solutions: {
    sidebarDesc: "Transform spending into a strategic investment with our suite of solutions.",
    items: [
      { title: "Cost Optimization", desc: "Eliminate waste and improve margins.", path: "/solutions/cost-optimization" },
      { title: "Regulatory Compliance", desc: "Continuous requirement across all functions.", path: "/solutions/regulatory-compliance" },
      { title: "Operational Efficiency", desc: "Strategic streamlining and strong control.", path: "/solutions/operational-efficiency" },
      { title: "Digital Transformation", desc: "Replace fragmented, manual operations.", path: "/solutions/digital-transformation" },
    ]
  },
  Products: {
    sidebarDesc: "Cutting-edge software tools designed for enterprise scale.",
    items: [
      { title: "Fixed Asset Management", desc: "Automated tracking and depreciation.", path: "/products/fam" },
      { title: "IT Asset Management", desc: "Real-time data processing and visualization.", path: "/products/itam" },
      { title: "IT Service Management", desc: "Strategic value center for your team.", path: "/products/itsm" },
      { title: "KYC Verification", desc: "Secure identity management systems.", path: "/products/kyc" },
      { title: "Remote Desktop", desc: "Seamless remote access solutions.", path: "/products/remote-desktop" },
      { title: "Property Management", desc: "Physical assets and property operations.", path: "/products/property-management" },
      // { title: "ILLEGAL CONSTRUCTION", desc: "MeltX enables authorities and institutions to manage illegal construction cases", path: "/products/illagal" },
      { title: "Customizable Solutions", desc: "MeltX Customizable Solutions enable organizations to build applications ", path: "/products/customizablesolution" },
      { title: "Integrated Services", desc: "MeltX Integrated Services complement our platforms ", path: "/products/integratedservices" },
    ]
  },
};

const Header = () => {
  const [activeMenu, setActiveMenu] = useState(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [mobileExpanded, setMobileExpanded] = useState(null);
  const [isScrolled, setIsScrolled] = useState(false);
  const closeBtnRef = useRef(null);
  const headerRef = useRef(null);
  const megaMenuRef = useRef(null);
  const mobileMenuRef = useRef(null);
  const backdropRef = useRef(null);
  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY > 50;
      setIsScrolled(scrolled);
      gsap.to(headerRef.current, {
        backgroundColor: scrolled ? "rgba(255, 255, 255, 0.95)" : "rgba(255, 255, 255, 1)",
        backdropFilter: scrolled ? "blur(10px)" : "blur(0px)",
        boxShadow: scrolled ? "0 10px 30px rgba(0,0,0,0.05)" : "none",
        paddingTop: scrolled ? "10px" : "16px",
        paddingBottom: scrolled ? "10px" : "16px",
        duration: 0.4
      });
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    if (activeMenu && megaMenuRef.current) {
      const tl = gsap.timeline();
      gsap.to(backdropRef.current, { opacity: 1, visibility: 'visible', duration: 0.3 });
      tl.fromTo(megaMenuRef.current,
        { clipPath: "inset(0% 0% 100% 0%)", opacity: 0 },
        { clipPath: "inset(0% 0% 0% 0%)", opacity: 1, duration: 0.6, ease: "expo.out" }
      );
      tl.fromTo(".mega-item",
        { y: 30, opacity: 0, scale: 0.95 },
        { y: 0, opacity: 1, scale: 1, stagger: 0.04, duration: 0.5, ease: "back.out(1.7)" },
        "-=0.4"
      );
    } else {
      gsap.to(backdropRef.current, { opacity: 0, visibility: 'hidden', duration: 0.3 });
    }
  }, [activeMenu]);

  useEffect(() => {
    if (isMobileMenuOpen) {
      const tl = gsap.timeline();
      tl.fromTo(mobileMenuRef.current,
        { clipPath: "circle(0% at 90% 5%)", visibility: "visible" },
        { clipPath: "circle(150% at 90% 5%)", duration: 0.8, ease: "power4.inOut" }
      );

      tl.fromTo(closeBtnRef.current,
        { rotation: -90, opacity: 0, scale: 0.5 },
        { rotation: 0, opacity: 1, scale: 1, duration: 0.5, ease: "back.out(1.7)" },
        "-=0.6"
      );
      tl.fromTo(".mobile-nav-item",
        { y: 40, opacity: 0 },
        { y: 0, opacity: 1, stagger: 0.1, duration: 0.5, ease: "back.out(1.2)" },
        "-=0.4"
      );
      document.body.style.overflow = 'hidden';
    } else {

      gsap.to(closeBtnRef.current, { rotation: 90, opacity: 0, scale: 0.5, duration: 0.3 });
      gsap.to(mobileMenuRef.current, {
        clipPath: "circle(0% at 90% 5%)",
        duration: 0.6,
        ease: "power4.inOut",
        onComplete: () => gsap.set(mobileMenuRef.current, { visibility: "hidden" })
      });
      document.body.style.overflow = 'unset';
    }
  }, [isMobileMenuOpen]);
  const toggleMobileSub = (name) => {
    const selector = `#sub-mobile-${name}`;
    if (mobileExpanded === name) {
      gsap.to(selector, { height: 0, opacity: 0, duration: 0.4, ease: "power2.inOut" });
      setMobileExpanded(null);
    } else {
      if (mobileExpanded) gsap.to(`#sub-mobile-${mobileExpanded}`, { height: 0, opacity: 0, duration: 0.3 });
      setMobileExpanded(name);
      gsap.fromTo(selector,
        { height: 0, opacity: 0 },
        { height: "auto", opacity: 1, duration: 0.5, ease: "power2.out" }
      );
    }
  };
  const handleDemo = (e) => {
    if (e) e.stopPropagation();
    setIsMobileMenuOpen(false);
    setActiveMenu(null);
    navigate('/contact-us/');
  }
  return (
    <>
      <div
        ref={backdropRef}
        className="fixed inset-0 bg-black/10 invisible opacity-0 z-[40] transition-all pointer-events-none"
      />

      <header
        ref={headerRef}
        className="fixed top-0 left-0 w-full z-[100]  px-[20px] md:px-[60px] py-[30px]"
        onMouseLeave={() => setActiveMenu(null)}
      >
        <div className="mx-auto flex items-center justify-between relative z-[110]">
          <Link to="/"><img src={logo} alt="Logo" className="w-[140px] md:w-[200px]" /></Link>

          <nav className="hidden lg:flex items-center gap-[40px]">
            {navLinks.map((link) => (
              <div key={link.name} className="relative py-4 group" onMouseEnter={() => link.hasSub ? setActiveMenu(link.name) : setActiveMenu(null)}>
                <Link to={link.path} className={`text-[20px] transition-colors duration-300 ${activeMenu === link.name ? "text-[#666CFF]" : "text-[#252625]"}`}>
                  {link.name}
                </Link>
                <span className={`absolute bottom-2 left-0 h-[2px] bg-[#666CFF] transition-all duration-500 ${activeMenu === link.name ? "w-full" : "w-0"}`} />
              </div>
            ))}
          </nav>

          <div className="flex items-center gap-4">
            <div className="hidden sm:block"><CommonButton title="BOOK A DEMO" onClick={handleDemo} /></div>
            <button className="lg:hidden w-10 h-10 flex flex-col justify-center gap-1.5 items-end group" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
              <span className={`h-[2px] bg-black transition-all duration-500 ${isMobileMenuOpen ? 'w-8 rotate-45 translate-y-2' : 'w-8'}`} />
              <span className={`h-[2px] bg-black transition-all duration-500 ${isMobileMenuOpen ? 'opacity-0' : 'w-5'}`} />
              <span className={`h-[2px] bg-black transition-all duration-500 ${isMobileMenuOpen ? 'w-8 -rotate-45 -translate-y-2' : 'w-3'}`} />
            </button>
          </div>
        </div>
        {activeMenu && megaMenuData[activeMenu] && (
          <div ref={megaMenuRef} className="absolute top-[90%] left-0 right-0 mx-[20px] md:mx-[60px] bg-white rounded-3xl shadow-[0_30px_100px_rgba(0,0,0,0.1)] border border-gray-100 overflow-hidden">
            <div className="grid grid-cols-12">
              <div className="col-span-3 p-10 bg-[#F9F9FF]">
                <h3 className="text-2xl font-[500] text-[#666CFF] mb-4">{activeMenu}</h3>
                <p className="text-[#808080] text-sm leading-relaxed">{megaMenuData[activeMenu].sidebarDesc}</p>
                <div className="w-10 h-[2px] bg-[#666CFF]" />
              </div>
              <div className={`col-span-9 p-10 grid gap-8 ${activeMenu === 'Solutions' ? 'grid-cols-2' : 'grid-cols-3'}`}>
                {megaMenuData[activeMenu].items.map((item, i) => (
                  <Link key={i} to={item.path} className="mega-item group block p-4 rounded-2xl hover:bg-[#666CFF08] transition-all" onClick={() => setActiveMenu(null)}>
                    <h4 className="font-[500] text-[22px] text-[#252625] group-hover:text-[#666CFF] transition-colors mb-1 flex items-center gap-2">
                      {item.title} <span className=" opacity-0 group-hover:opacity-100 group-hover:translate-x-1 transition-all">→</span>
                    </h4>
                    <p className="text-[18px] text-gray-400 leading-relaxed">{item.desc}</p>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        )}
      </header>
      <div
        ref={mobileMenuRef}
        className="fixed inset-0 bg-white z-[105] invisible lg:hidden flex flex-col  px-[20px] overflow-y-auto"
      >
        <nav className="flex flex-col space-y-2 pt-4">
          <span
            ref={closeBtnRef}
            className="material-symbols-outlined absolute top-[15px] right-[10px] w-10 h-10 flex items-center justify-center cursor-pointer text-[#252625] hover:text-[#666CFF] transition-colors duration-300 z-[110]"
            style={{ fontSize: '32px' }}
            onClick={() => setIsMobileMenuOpen(false)}
          >
            close
          </span>
          {navLinks.map((link, i) => (
            <div key={i} className="mobile-nav-item border-b border-gray-50 overflow-hidden">
              <div className="flex justify-between items-center pb-2">

                {link.hasSub ? (

                  <div
                    className={`text-[20px] font-[500] cursor-pointer transition-colors w-full py-2 ${mobileExpanded === link.name ? 'text-[#666CFF]' : 'text-[#252625]'
                      }`}
                    onClick={() => toggleMobileSub(link.name)}
                  >
                    {link.name}
                  </div>
                ) : (
                  <Link
                    to={link.path}
                    className="text-[20px] font-[500] text-[#252625] w-full py-2"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    {link.name}
                  </Link>
                )}

                {link.hasSub && (
                  <button
                    onClick={() => toggleMobileSub(link.name)}
                    className="flex items-center justify-center rounded-full transition-all active:scale-90"
                    aria-label="Toggle Submenu"
                  >
                    <span
                      className={`material-symbols-outlined text-[32px] transition-all duration-500 ease-out ${mobileExpanded === link.name
                        ? 'rotate-180 text-[#666CFF]'
                        : 'text-[#252625]'
                        }`}
                    >
                      expand_more
                    </span>
                  </button>
                )}
              </div>
              {link.hasSub && (
                <div id={`sub-mobile-${link.name}`} className="h-0 opacity-0 overflow-hidden bg-gray-50/50 rounded-2xl">
                  <div className="p-4 space-y-6">
                    {megaMenuData[link.name]?.items.map((item, idx) => (
                      <Link
                        key={idx}
                        to={item.path}
                        className="block group"
                        onClick={() => setIsMobileMenuOpen(false)}
                      >
                        <h4 className="text-lg font-[500] text-[#252625] group-hover:text-[#666CFF] transition-colors">
                          {item.title}
                        </h4>
                        <p className="text-xs text-[#808080] mt-1 leading-tight">
                          {item.desc}
                        </p>
                      </Link>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </nav>

        <div className="mobile-nav-item mt-10 pb-10">
          <CommonButton

            title="BOOK A DEMO"
            onClick={handleDemo}
            className="flex items-center  uppercase  animate-inside-pulse  inner-shine transform-none transition-none"
          />
        </div>
      </div>
    </>
  )
}

export default Header
